import React, { useState } from "react";
import "./Homepage.css";

// --- END VIDEO IMPORTS REMOVED ---

import visualsThumb from './assets/visualsThumb.png';
import ImageModal from "./components/ImageModal";
import adobeThumb from './assets/adobe research/adobe_thumb.png';
import goThumb from './assets/goThumb.png';


export default function Homepage() {
  const [selectedWork, setSelectedWork] = useState(null);


  const workItems = [
    { title: 'Adobe Research', thumbnail: adobeThumb, link: "https://www.youtube.com/watch?v=c1lzncIhoaU&t=9s&ab_channel=Adobe"},
    { title: 'visuals...', thumbnail: visualsThumb, link: "https://vimeo.com/1147208889?share=copy&fl=sv&fe=ci" },
    { title: 'WATCH ME GO! (spec)', thumbnail: goThumb, link: "https://vimeo.com/1147208889?share=copy&fl=sv&fe=ci" },
  ];


  

  return (
    <>
      {/* ─── HERO SECTION (solid black) ───────────────────────── */}
      <section className="hero-banner">
        <div className="hero-overlay">
         

          <div className="hero-text">
            <p className="hero-subheadline">
              We are a creative studio focused on strategy-led video editing<br />
            </p>
          </div>

        </div>
      </section>

    
           

      {/* ─── RECENT WORK ─────────────────────────── */}
      <section className="recent-work">
        <h1 className="recent-work-heading">Work</h1>
        <div className="scroll-container">
          {workItems.map(item => (
            <div key={item.title} className="work-card" onClick={() => setSelectedWork(item)}>
              <img className="work-thumb" src={item.thumbnail} alt={item.title} />
              <h1 className="work-title-homepage">{item.title}</h1>
            </div>
          ))}
        </div>
      </section>

      {selectedWork && (
        <ImageModal
          open
          onClose={() => setSelectedWork(null)}
          src={selectedWork.thumbnail}
          alt={selectedWork.title}
          caption={selectedWork.title}
          link={selectedWork.link}
        />
      )}

      

      {/* ─── FOOTER ───────────────────────────────── */}
      <footer className="site-footer">
        <div className="footer-inner">
          <nav className="footer-nav">
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/blog">Blog</a>
          </nav>
          <p className="footer-legal">
            © {new Date().getFullYear()} Kaya Visuals · Austin, TX
          </p>
        </div>
      </footer>
    </>
  );
}
